import { render, staticRenderFns } from "./editOrderModalContent.vue?vue&type=template&id=f70ba7e4&scoped=true"
import script from "./editOrderModalContent.vue?vue&type=script&lang=js"
export * from "./editOrderModalContent.vue?vue&type=script&lang=js"
import style0 from "./editOrderModalContent.vue?vue&type=style&index=0&id=f70ba7e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70ba7e4",
  null
  
)

export default component.exports